import { render, staticRenderFns } from "./foody_general_tab.vue?vue&type=template&id=f0ce6546&scoped=true&"
import script from "./foody_general_tab.vue?vue&type=script&lang=js&"
export * from "./foody_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ce6546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ce6546')) {
      api.createRecord('f0ce6546', component.options)
    } else {
      api.reload('f0ce6546', component.options)
    }
    module.hot.accept("./foody_general_tab.vue?vue&type=template&id=f0ce6546&scoped=true&", function () {
      api.rerender('f0ce6546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/foody/location/tabs/foody_general_tab.vue"
export default component.exports